import React from 'react';
import styles from "./Button.module.css"
const Button = ({ title, onClick }) => {

    return (
        <div>
            <button onClick={onClick} className={styles.button}>{title}</button>
        </div>
    );
};

export default Button;